import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

interface PhoneNumberInputProps {
  inputValue: string;
  label?: string;
  name?: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement, Element>) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  countryCodeDisabled?: boolean;
  placeholder?: string;
  required?: boolean;
  error?: string;
}

export default function PhoneNumberInput({
  countryCodeDisabled = true,
  inputValue,
  label,
  name,
  onChange,
  onBlur,
  className,
  placeholder = 'eg. 0812345789',
  required = false,
  error,
}: PhoneNumberInputProps) {
  const handlePhoneChange = (phone: string) => {
    const event = {
      target: {
        name: name,
        value: phone,
      },
    } as React.ChangeEvent<HTMLInputElement>;
    onChange(event);
  };

  return (
    <div className="mb-3">
      {/* <label htmlFor={name} className="block text-gray-600 font-medium">
        {label} {required && <span className="text-red-500">*</span>}
      </label> */}
      {label && (
        <label className={error ? 'errorText' : ''} htmlFor={name}>
          {label}
          {required && <span className="text-red-error">*</span>}
        </label>
      )}
      <PhoneInput
        country={'ng'}
        onlyCountries={['ng']}
        inputStyle={{
          width: '100%',
          height: '46px',
          paddingTop: '0.4rem',
          paddingBottom: '0.4rem',
          borderRadius: '8px',
          color: '#1F2937',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
          boxSizing: 'border-box',
          borderColor: 'rgba(209, 213, 219, 1)',
          fontSize: '1rem',
          lineHeight: '1.5',
          transition: 'box-shadow 0.2s ease-in-out',
          // marginBottom: '8px',
        }}
        value={inputValue}
        countryCodeEditable={false}
        onBlur={(e) => onBlur && onBlur(e)}
        inputClass={`default-input-class rounded-md ${className} ${
          error ? 'inputError' : ''
        }`}
        onChange={handlePhoneChange}
        placeholder={placeholder}
        inputProps={{
          required: required,
          name: name,
        }}
      />
      {error && <div className="error mb-3">{error}</div>}
    </div>
  );
}
